import React from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import BandeauConditions from './BandeauConditions';
import { ProjectTreeProvider } from '../../contexts/ProjectTreeContext';

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  return (
    <ProjectTreeProvider>
      <div className="flex h-screen bg-surface-0 overflow-hidden">
        <Sidebar />
        <div className="flex-1 flex flex-col min-w-0">
          <TopBar />
          {/* SOUS la barre et HORS de `main` : il ne doit pas defiler avec le contenu,
              ni etre rendu une fois par ecran. Il se retire tout seul des que la version
              courante est acceptee. */}
          <BandeauConditions />
          <main className="flex-1 overflow-y-auto p-6 pl-8">
            {children}
          </main>
        </div>
      </div>
    </ProjectTreeProvider>
  );
};

export default AppLayout;
